import { Component, Input, OnInit } from '@angular/core';
import {
  CardLinkAffiliate,
  CardLinkAffiliatesQuery,
  CardLinkAffiliatesService,
  CardLinkOffersQuery,
  Company,
  MemberQuery,
  UserContext,
} from '@fgb/core';
import { Observable } from 'rxjs';
@Component({
  selector: 'fgbcl-card-link-featured-brands',
  templateUrl: './card-link-featured-brands.component.html',
  styleUrls: ['./card-link-featured-brands.component.scss'],
})
export class CardLinkFeaturedBrandsComponent implements OnInit {
  featuredPartners$: Observable<CardLinkAffiliate[] | undefined>;
  userContext: UserContext;
  @Input() Title: string = '';

  constructor(
    private memberQuery: MemberQuery,
    private cardLinkAffiliatesService: CardLinkAffiliatesService,
    private cardLinkAffiliatesQuery: CardLinkAffiliatesQuery,
    private cardLinkOffersQuery: CardLinkOffersQuery
  ) {}

  ngOnInit(): void {
    this.userContext = this.memberQuery.getUserContext();
    this.cardLinkAffiliatesService.fetchAffiliates(this.userContext.clubId, this.userContext.lcid).toPromise();
    this.featuredPartners$ = this.cardLinkAffiliatesQuery.selectAll({
      filterBy: [({ Favourite }) => Favourite],
    });
  }

  /**
   * to navigate on first offer of selected brand
   */
  navigateToFirstOfferFromAffiliate(company: Company) {
    this.cardLinkOffersQuery.navigateToCompaniesFirstOffer(company.CompanyId).subscribe().unsubscribe();
  }
}
